import { IWorkplacesSchema } from 'shared/repositories/coworking/entities/workplaces/WorkplacesSchema';

export enum ECoworkingSwitcherType {
  Office = 'office',
  Places = 'places',
}

export interface IAvailableSpacesProps {
  isFlexOfficeAvailable: boolean;
  className?: string;
  workplaces: IWorkplacesSchema | null;
}
